function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.26,
    height: 13.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7722222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 6.95,
    fontFamily: "Arial"
  }, "\n        Manassas_Park_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.9,
    width: 22.26,
    height: 14.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9613333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 21.11,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.32,
    width: 22.26,
    height: 17.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5554545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 36.875,
    fontFamily: "Arial"
  }, "\n        Norton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.42,
    width: 22.26,
    height: 19.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0688888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 55.04,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64.66,
    width: 22.26,
    height: 20.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 75.085,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.51,
    width: 22.26,
    height: 21.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 96.14,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.77,
    width: 22.26,
    height: 21.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7758333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 117.425,
    fontFamily: "Arial"
  }, "\n        Emporia_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.08,
    width: 22.26,
    height: 22.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 139.17000000000002,
    fontFamily: "Arial"
  }, "\n        Lexington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 150.27,
    width: 22.26,
    height: 22.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.023636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 161.425,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.57,
    width: 22.26,
    height: 24.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.226
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 184.75,
    fontFamily: "Arial"
  }, "\n        Galax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 196.93,
    width: 22.26,
    height: 26.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 210.125,
    fontFamily: "Arial"
  }, "\n        Bedford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 223.32,
    width: 22.26,
    height: 26.5,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.171578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 236.57,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 249.82,
    width: 22.26,
    height: 27.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 263.48,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.14,
    width: 22.26,
    height: 27.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 290.95,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.76,
    width: 22.26,
    height: 27.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.171578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 318.64,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 332.52,
    width: 22.26,
    height: 28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4840000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 346.52,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.52,
    width: 22.26,
    height: 29.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3094117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 375.35499999999996,
    fontFamily: "Arial"
  }, "\n        South_Boston_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.19,
    width: 22.26,
    height: 30.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7123076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 405.575,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 420.96,
    width: 22.26,
    height: 32.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7123076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 437.01,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 453.06,
    width: 22.26,
    height: 32.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 469.275,
    fontFamily: "Arial"
  }, "\n        Covington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 485.49,
    width: 22.26,
    height: 34.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3094117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 502.56,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.63,
    width: 22.26,
    height: 34.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 536.91,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 554.19,
    width: 22.26,
    height: 34.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3094117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 571.6350000000001,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 589.08,
    width: 22.26,
    height: 35.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 606.72,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 624.36,
    width: 22.26,
    height: 37.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4840000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 642.88,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 661.41,
    width: 22.26,
    height: 38.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7123076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.13,
    y: 680.7049999999999,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 0,
    width: 27.17,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0900000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.845,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 0,
    width: 27.43,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5238888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.135000000000005,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.86,
    y: 0,
    width: 27.75,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.734375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.735,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 0,
    width: 27.85,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8566666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.52499999999999,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 0,
    width: 28.6,
    height: 31.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.042857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.75,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.05,
    y: 0,
    width: 28.96,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.53,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.01,
    y: 0,
    width: 30.6,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6105263157894738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.31,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 0,
    width: 30.91,
    height: 31.96,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3776923076923078
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.055,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Poquoson_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.51,
    y: 0,
    width: 32.32,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.67,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.84,
    y: 0,
    width: 32.71,
    height: 31.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8800000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.195,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.55,
    y: 0,
    width: 33.05,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5219047619047619
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.075,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.6,
    y: 0,
    width: 33.34,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6633333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.27000000000004,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.94,
    y: 0,
    width: 33.79,
    height: 31.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4584615384615387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.835,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.73,
    y: 0,
    width: 34.08,
    height: 31.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7755555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.77000000000004,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.81,
    y: 0,
    width: 34.66,
    height: 31.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4584615384615387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.14,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.47,
    y: 0,
    width: 34.68,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.81,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.15,
    y: 0,
    width: 35.22,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8800000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.76,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.37,
    y: 0,
    width: 35.97,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 573.355,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.35,
    y: 0,
    width: 36.02,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.36,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.37,
    y: 0,
    width: 36.2,
    height: 31.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6633333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.47,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 663.57,
    y: 0,
    width: 36.43,
    height: 31.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8800000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.7850000000001,
    y: 15.98,
    fontFamily: "Arial"
  }, "\n        Falls_Church_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 31.96,
    width: 38.25,
    height: 31.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7261111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 47.495000000000005,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 63.04,
    width: 38.25,
    height: 31.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.119333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 78.935,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 94.82,
    width: 38.25,
    height: 33.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 111.58,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 128.34,
    width: 38.25,
    height: 33.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.778421052631579
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 145.235,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 162.14,
    width: 38.25,
    height: 34.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.304666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 179.42499999999998,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 196.71,
    width: 38.25,
    height: 35.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8757894736842105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 214.53,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 232.35,
    width: 38.25,
    height: 36.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 250.47,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 268.6,
    width: 38.25,
    height: 36.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4186666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 286.74,
    fontFamily: "Arial"
  }, "\n        Waynesboro_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 304.87,
    width: 38.25,
    height: 36.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.442
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 323.185,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 341.5,
    width: 38.25,
    height: 36.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8370000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 359.87,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 378.24,
    width: 38.25,
    height: 36.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1741176470588237
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 396.72,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 415.2,
    width: 38.25,
    height: 38.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9423076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 434.495,
    fontFamily: "Arial"
  }, "\n        Manassas_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 453.79,
    width: 38.25,
    height: 39.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9423076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 473.315,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 492.83,
    width: 38.25,
    height: 39.83,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.732142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 512.745,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 532.66,
    width: 38.25,
    height: 40.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9423076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 553.015,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 573.37,
    width: 38.25,
    height: 41.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.732142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 593.93,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 614.48,
    width: 38.25,
    height: 42.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 635.82,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 657.16,
    width: 38.25,
    height: 42.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.385000000000005,
    y: 678.5799999999999,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 31.96,
    width: 38.42,
    height: 43.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2600000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.72,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.93,
    y: 31.96,
    width: 39.51,
    height: 43.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.685,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.43,
    y: 31.96,
    width: 39.55,
    height: 43.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.295833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.205,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.99,
    y: 31.96,
    width: 39.82,
    height: 43.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.9,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.81,
    y: 31.96,
    width: 40.41,
    height: 43.1,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9242857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.015,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.22,
    y: 31.96,
    width: 40.41,
    height: 43.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.108461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.425,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.63,
    y: 31.96,
    width: 40.57,
    height: 43.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3864705882352943
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.915,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: 31.96,
    width: 41.98,
    height: 43.1,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.2,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.18,
    y: 31.96,
    width: 42.64,
    height: 43.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.368888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.5,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.82,
    y: 31.96,
    width: 42.97,
    height: 43.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.685625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.305,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.8,
    y: 31.96,
    width: 43.41,
    height: 43.1,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3153846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.505,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.2,
    y: 31.96,
    width: 43.92,
    height: 43.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3153846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.16,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.12,
    y: 31.96,
    width: 46.84,
    height: 43.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.54,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.96,
    y: 31.96,
    width: 49.2,
    height: 43.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.5600000000001,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.15,
    y: 31.96,
    width: 49.85,
    height: 43.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1550000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.0749999999999,
    y: 53.510000000000005,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 75.06,
    width: 49.84,
    height: 43.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 96.9,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 118.75,
    width: 49.84,
    height: 44.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.493
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 141.215,
    fontFamily: "Arial"
  }, "\n        Salem_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 163.68,
    width: 49.84,
    height: 44.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.748333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 186.17000000000002,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 208.66,
    width: 49.84,
    height: 45.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.765833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 231.255,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 253.84,
    width: 49.84,
    height: 45.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7005882352941173
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 276.795,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 299.76,
    width: 49.84,
    height: 45.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 322.755,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 345.75,
    width: 49.84,
    height: 47.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 369.375,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 393,
    width: 49.84,
    height: 48.23,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 417.115,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 441.22,
    width: 49.84,
    height: 48.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8340000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 465.39000000000004,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 489.56,
    width: 49.84,
    height: 48.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.876470588235294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 514.01,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 538.46,
    width: 49.84,
    height: 50.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 563.885,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 589.31,
    width: 49.84,
    height: 54.5,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9317647058823533
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 616.56,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.51,
    y: 643.82,
    width: 49.84,
    height: 56.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.43,
    y: 671.9100000000001,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 75.06,
    width: 49.47,
    height: 56.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.603684210526316
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.08499999999998,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.82,
    y: 75.06,
    width: 50.15,
    height: 56.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.89499999999998,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.97,
    y: 75.06,
    width: 50.69,
    height: 56.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6207142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.315,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.66,
    y: 75.06,
    width: 51.09,
    height: 56.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6492857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.20500000000004,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.75,
    y: 75.06,
    width: 51.34,
    height: 56.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.42,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 75.06,
    width: 51.54,
    height: 56.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.87,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.64,
    y: 75.06,
    width: 52.51,
    height: 56.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5006666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.895,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.15,
    y: 75.06,
    width: 57.56,
    height: 56.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.837
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.92999999999995,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.71,
    y: 75.06,
    width: 57.68,
    height: 56.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.158181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.5500000000001,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.39,
    y: 75.06,
    width: 58.14,
    height: 56.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7826666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.46,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.53,
    y: 75.06,
    width: 59.47,
    height: 56.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7826666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.265,
    y: 103.43,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 131.8,
    width: 62.04,
    height: 55.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6973333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 159.53,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 187.26,
    width: 62.04,
    height: 55.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9992857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 215.255,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 243.26,
    width: 62.04,
    height: 56.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.15090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 271.59,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 299.92,
    width: 62.04,
    height: 65.52,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6494117647058824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 332.68,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 365.44,
    width: 62.04,
    height: 65.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6494117647058824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 398.235,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 431.03,
    width: 62.04,
    height: 65.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 463.955,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 496.88,
    width: 62.04,
    height: 65.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 529.855,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 562.83,
    width: 62.04,
    height: 66.82,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.772307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 596.24,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.35,
    y: 629.65,
    width: 62.04,
    height: 70.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 664.8249999999999,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 131.8,
    width: 65.69,
    height: 67.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.692142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.225,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.08,
    y: 131.8,
    width: 67.2,
    height: 67.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.949411764705882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.68,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.27,
    y: 131.8,
    width: 67.67,
    height: 67.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.10499999999996,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.95,
    y: 131.8,
    width: 76.6,
    height: 67.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.19625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.25,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.54,
    y: 131.8,
    width: 80.63,
    height: 67.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.795714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.855,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.18,
    y: 131.8,
    width: 80.99,
    height: 67.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.533684210526316
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.675,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.17,
    y: 131.8,
    width: 88.83,
    height: 67.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.795714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.5849999999999,
    y: 165.37,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 198.94,
    width: 83,
    height: 73.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.259285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.88,
    y: 235.755,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 272.57,
    width: 83,
    height: 93.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.928571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.88,
    y: 319.4,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 366.23,
    width: 83,
    height: 100.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.88,
    y: 416.41,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 466.59,
    width: 83,
    height: 112.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.533333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.88,
    y: 522.6949999999999,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.38,
    y: 578.8,
    width: 83,
    height: 121.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.88,
    y: 639.4,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.38,
    y: 198.94,
    width: 101.14,
    height: 100.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.723333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.95,
    y: 249.365,
    fontFamily: "Arial"
  }, "\n        Chesapeake_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.52,
    y: 198.94,
    width: 102.43,
    height: 100.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.723333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.735,
    y: 249.365,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.95,
    y: 198.94,
    width: 114.99,
    height: 100.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.802380952380952
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.4449999999999,
    y: 249.365,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.93,
    y: 198.94,
    width: 126.07,
    height: 100.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.93235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.9649999999999,
    y: 249.365,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.38,
    y: 299.79,
    width: 123.52,
    height: 127.16,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.501052631578947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.14,
    y: 363.37,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.38,
    y: 426.95,
    width: 123.52,
    height: 133.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.14,
    y: 493.7,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.38,
    y: 560.45,
    width: 123.52,
    height: 139.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.293333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.14,
    y: 630.225,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.9,
    y: 299.79,
    width: 157.62,
    height: 123.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.839285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.71,
    y: 361.665,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.52,
    y: 299.79,
    width: 163.48,
    height: 123.75,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.51923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.26,
    y: 361.665,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.9,
    y: 423.54,
    width: 80.58,
    height: 276.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.241052631578947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.19,
    y: 561.77,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.48,
    y: 423.54,
    width: 240.52,
    height: 276.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.74,
    y: 561.77,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.86b605c1ae51718ef2b9788a74961687.svg";
export { ForwardRef as ReactComponent };